import React from 'react';
import PropTypes from 'prop-types';
import {Step, StepButton, StepContent} from 'material-ui/Stepper';
import {red500, amber500} from 'material-ui/styles/colors';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import DoneIcon from 'material-ui/svg-icons/action/done';
import Scroll from 'react-scroll';
import log from 'utils/logger';

const logger = log('CustomStep');

const Element = Scroll.Element;

class CustomStep extends React.Component {

    constructor(props) {
        super(props);

        this.handleStepClick = this
            .handleStepClick
            .bind(this);
    }

    handleStepClick(e) {
        e.preventDefault();
        const {orderId, onStepClick, stepConfig, stepConfigKey} = this.props;

        onStepClick(stepConfig[stepConfigKey].index, orderId);

    }

    render() {
        const {
            stepKey,
            label,
            stepConfig,
            stepConfigKey,
            activeStep,
            stepValidation,
            children,
            orderCloseDetails
        } = this.props;

        if (!stepConfig[stepConfigKey]) {
            logger.warn(`No step found for ${stepConfigKey}`);
            return null;
        }

        const index = stepConfig[stepConfigKey].index;

        const stepDisabled = !stepConfig.checkAllPreviousStepsValid(index, orderCloseDetails);

        let icon = index + 1,
            message;

        const labelStyle = {};

        if (!stepValidation.getIn([stepKey, 'isValid'])) {
            icon = (<WarningIcon color={red500}/>);
            labelStyle.color = red500;

            message = (
                <span style={{
                    color: red500
                }}>{stepValidation.getIn([stepKey, 'message'])}</span>
            );
        }

        if (stepValidation.getIn([stepKey, 'isValid'])) {
            icon = (<DoneIcon/>);

            message = (
                <span>{stepValidation.getIn([stepKey, 'message'])}</span>
            );
        }

        if (stepValidation.getIn([stepKey, 'isWarning'])) {
            icon = (<WarningIcon color={amber500}/>);
            labelStyle.color = amber500;

            message = (
                <span style={{
                    color: amber500
                }}>{stepValidation.getIn([stepKey, 'message'])}</span>
            );
        }

        return (

            <Step index={index} active={activeStep === index}>
                <StepButton
                    disabled={stepDisabled}
                    onTouchTap={this.handleStepClick}
                    icon={icon}
                    active={activeStep === index}
                    style={labelStyle}>
                    <Element name={`step_${index}`}>
                        {label}
                    </Element>
                </StepButton>

                <StepContent active={activeStep === index}>
                    <div style={{
                        width: '98%'
                    }}>
                        {message}
                        {children}

                    </div>
                </StepContent>
            </Step>

        );

    }
}

CustomStep.propTypes = {

    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
    stepConfigKey: PropTypes.string,
    activeStep: PropTypes.number,
    stepValidation: PropTypes.object,
    onStepClick: PropTypes.func,
    stepKey: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.object,
    orderCloseDetails: PropTypes.object
};

export default CustomStep;


// WEBPACK FOOTER //
// ./src/components/work-order/close/CustomStep.js